import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Label, Modal, Button} from "reactstrap";
import {Formik, Field, Form, ErrorMessage} from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import {companiesNew, companiesEdit} from "../../store/companies/actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {capitalizeFirst, removeEmptyFormField} from "../../common/general";
import SwitchField from "../../components/Common/SwitchField";

class NewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: ""
    }
  }

  onClose = () => {
    this.props.togModal()
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        loading: this.props.loading,
        error: this.props.error
      });
      if (this.props.responseNew.status === 0) {
        this.props.refreshParent({history: this.props.history})
        this.onClose()
      }
    }
  }

  render() {
    const requiredName = Yup.string().required("Please Enter Name")
    const requiredCrn = Yup.string().required("Please Enter Crn")

    let initialValues = {
      name: this.props.action === "new" ? "" : this.props.companyData.name,
      crn: this.props.action === "new" ? "" : this.props.companyData.crn,
      tax_id: this.props.action === "new" ? "" : this.props.companyData.tax_id,
      vat_id: this.props.action === "new" ? "" : this.props.companyData.vat_id,
    }

    if (this.props.action === "new") {
      initialValues = {
        ...initialValues,
        create_section: false,
        create_user: false,
      }
    }

    return (<React.Fragment>
        <Modal isOpen={true} toggle={this.onClose}>
          <div className="modal-header">
            <h5 className="modal-title mt-0">
              {capitalizeFirst(this.props.action)} Company
            </h5>
            <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={Yup.object().shape({
              name: Yup.string().min(3, 'Name is too short').max(128, 'Name is too long').concat(this.props.companyData.values === null ? requiredName : null),
              crn: Yup.string().min(3, 'Crn is too short').max(16, 'Crn is too long').concat(this.props.companyData.values === null ? requiredCrn : null),
              tax_id: Yup.string().min(3, 'Tax Id is too short').max(16, 'Tax Id is too long'),
              vat_id: Yup.string().min(3, 'Vat Id is too short').max(16, 'Vat Id is too long'),
            })}
            onSubmit={values => {
              const {onCompaniesNew, onCompaniesEdit} = this.props
              if (this.props.action === "new") {
                onCompaniesNew({history: this.props.history, values: values})
              } else {
                onCompaniesEdit({history: this.props.history, id: this.props.companyData.id, values: removeEmptyFormField(values)})
              }
            }}
          >
            {({errors, status, touched}) => (<Form>
              <div className="modal-body">
                <Row>
                  <Col lg="12" className="mb-1">
                    <FormGroup>
                      <Label htmlFor="name">
                        Name
                      </Label>
                      <Field
                        id="name"
                        name="name"
                        placeholder="Enter Name"
                        type="text"
                        className={"form-control" + (errors.name && touched.name ? " is-invalid" : "")}
                      />
                      <ErrorMessage name="name" component="div" className="invalid-feedback"/>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label htmlFor="crn">
                        Crn
                      </Label>
                      <Field
                        id="crn"
                        name="crn"
                        placeholder="Enter Crn"
                        type="text"
                        className={"form-control" + (errors.crn && touched.crn ? " is-invalid" : "")}
                      />
                      <ErrorMessage name="crn" component="div" className="invalid-feedback"/>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label htmlFor="tax_id">
                        Tax Id
                      </Label>
                      <Field
                        id="tax_id"
                        name="tax_id"
                        placeholder="Enter Tax Id"
                        type="text"
                        className={"form-control" + (errors.tax_id && touched.tax_id ? " is-invalid" : "")}
                      />
                      <ErrorMessage name="tax_id" component="div" className="invalid-feedback"/>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label htmlFor="vat_id">
                        Vat Id
                      </Label>
                      <Field
                        id="vat_id"
                        name="vat_id"
                        placeholder="Enter Vat Id"
                        type="text"
                        className={"form-control" + (errors.vat_id && touched.vat_id ? " is-invalid" : "")}
                      />
                      <ErrorMessage name="vat_id" component="div" className="invalid-feedback"/>
                    </FormGroup>
                  </Col>
                </Row>
                {this.props.action === "new" && (
                  <Row>
                    <Col>
                      <FormGroup>
                        <SwitchField id="create_section" name="Create Section" color="#02a499"/>
                      </FormGroup>
                    </Col>
                  </Row>)}
                {this.props.action === "new" && (
                  <Row>
                    <Col>
                      <FormGroup>
                        <SwitchField id="create_user" name="Create User" color="#02a499"/>
                      </FormGroup>
                    </Col>
                  </Row>)}
              </div>
              <div className="modal-footer">
                {this.state.loading && (<div className="spinner-border text-primary m-1 me-auto" role="status">
                  <span className="sr-only">Loading...</span>
                </div>)}
                {this.state.error.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                  {this.state.error}
                </Alert>)}
                <Button color="secondary" onClick={this.onClose} data-dismiss="modal">
                  Close
                </Button>
                <Button color="primary" type="submit">
                  Save
                </Button>
              </div>
            </Form>)}
          </Formik>
        </Modal>
      </React.Fragment>
    )
  }
}

NewModal.propTypes = {
  responseNew: PropTypes.any,
  onCompaniesNew: PropTypes.func,
  onCompaniesEdit: PropTypes.func,
};

const mapStateToProps = ({Companies}) => ({
  responseNew: Companies.responseNew,
  loading: Companies.loadingNew,
  error: Companies.errorNew,
});

const mapDispatchToProps = dispatch => ({
  onCompaniesNew: data => dispatch(companiesNew(data)),
  onCompaniesEdit: data => dispatch(companiesEdit(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewModal));